<div>
  <accordion>
    <accordion-group title="Upload Images">
      <app-image-upload></app-image-upload>
    </accordion-group>

    <accordion-group title="Images">
      <div class="images-table-container">

        <div class="table-responsive" >
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Org Code</th>
                <th>File Name</th>
                <th>Created By User Id</th>
                <th>Created On</th>
                <th>Thumbnail</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              @for(image of images(); let i = $index; track i) {
                <tr>
                  <td>{{image.orgCode}}</td>
                  <td>{{image.fileName}}</td>
                  <td>{{image.createdBy}}</td>
                  <td>{{image.createdOn | date:'short'}}</td>
                  <td>
                    @if (image.id) {
                      <app-image-thumbnail [imageId]="image.id"
                      (click)="openImagePopup(image)"></app-image-thumbnail>
                    } @else {
                      <span>No Image</span>
                    }
                  </td>
                  <td>
                    <button class="btn btn-sm" (click)="onDelete(image.id!)">
                      <i class="fas fa-trash" style="color: slategray;"></i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (selectedImageUrl()) {
          <app-image-popup [imageUrl]="selectedImageUrl()" (close)="closeImagePopup()">
          </app-image-popup>
        }
      </div>
    </accordion-group>
  </accordion>
</div>